<template>
  <div class="main-layout">
    <div
      ref="myDiv"
      class="nav-bar"
    >
      <Header />
      <top-menu />
    </div>
    <sidebar ref="sidebar" @toggle-sidebar="sidebarActive = !sidebarActive" />
    <div class="main-layout__container">
      <div class="main-layout__body" :style="mainLayoutBodyStyles">
        <img
          :class="['default-sidebar-icon', { 'sidebar-icon' : !isActiveAdminView, 'default-sidebar-icon--checkout': isCheckoutRoute, 'default-sidebar-icon--order-detail': isOrderDetailRoute }]"
          src="/img/icons/menu-bar.svg"
          width="22px"
          height="20px"
          @click="$refs.sidebar.openSidebar()"
        />
        <child />
      </div>
    </div>
    <new-order-modal @closeModal="closeNewOrderModal" />
    <IdleTimeAlert @showModal="showIdleTimeOutModal" @closeModal="closeIdleTimeOutModal" />
  </div>
</template>

<script>
import Header from '~/components/Header'
import TopMenu from '~/components/common/TopMenu/TopMenu'
import NewOrderModal from '../components/NewOrderModal.vue'
import Sidebar from '~/components/Sidebar'
import { mapState, mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import { ADMIN_ROUTES } from '../constants'
import IdleTimeAlert from '~/components/IdleTimeAlert.vue'
import { isTabletViewport } from '~/helpers/viewport'

export default {
  name: 'MainLayout',
  components: {
    IdleTimeAlert,
    Header,
    TopMenu,
    Sidebar,
    NewOrderModal
  },
  data() {
    return {
      isShowNewOrderModal: false,
      sidebarActive: false,
      menuIcon: false,
      windowWidth: window.innerWidth,
      isTablet: isTabletViewport()
    }
  },
  computed: {
    ...mapState({
      editModeMenus: (state) => state.menus.editMode,
      adminViewMode: (state) => state.menus.adminViewMode
    }),
    ...mapGetters({
      buildFilterData: 'menus/buildFilterData',
      isAssociate: 'auth/isAssociate'
    }),
    customWidth() {
      if (this.isTablet) {
        return 0
      }
      if ((this.isLaptop) && this.adminViewMode.show) {
        return 0
      }
      if (
        this.$route.name === 'shop-by-gallery' &&
        this.editModeMenus.show &&
        this.editModeMenus.shopByGalleryEditMode
      ) {
        return 0
      } else if (ADMIN_ROUTES.includes(this.$route.name) && this.adminViewMode && !this.isLaptop) {
        return '216px'
      } else {
        return '68px'
      }
    },
    mainLayoutBodyStyles() {
      return {
        minHeight: this.$route.name === 'settings' && this.isAssociate ? 'auto' : '1000px',
        paddingLeft:
          this.$route.name === 'shop-by-gallery' &&
          this.editModeMenus.show &&
          this.editModeMenus.shopByGalleryEditMode
            ? 0
            : this.customWidth
      }
    },
    // Checkout steps remount on every step change (Child keys router-view by path),
    // so this must follow the route, not a step component's lifecycle.
    isCheckoutRoute() {
      return this.$route.name?.startsWith('checkout-proceed.') ?? false
    },
    isOrderDetailRoute() {
      return this.$route.name === 'order.detail'
    },
    isActiveAdminView() {
      return (this.isLaptop) && this.adminViewMode.show
    },
    isLaptop () {
      return this.windowWidth < 1919
    }
  },
  mounted() {
    if (isEmpty(this.buildFilterData)) {
      this.fetchCommonMenu()
    }
    this.fetchOrders()
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
  methods: {
    ...mapActions({
      fetchCommonMenu: 'menus/fetchCommonMenu',
      fetchOrders: 'orders/fetchOrders'
    }),
    closeNewOrderModal() {
      this.isShowNewOrderModal = false
      this.$modal.hide('new-order-modal')
    },
    showIdleTimeOutModal() {
      this.$modal.show('idle-time-alert-modal')
    },

    closeIdleTimeOutModal() {
      this.$modal.hide('idle-time-alert-modal')
    },
    updateWindowWidth () {
      this.windowWidth = window.innerWidth
      this.isTablet = isTabletViewport()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout__container {
  position: relative;
}
.main-layout__body {
  @media only screen and (max-width: 560px) {
    padding-left: 0 !important;
  }
}
.nav-bar {
  transition: top 0.3s ease-in-out;
}
.sidebar-icon {
  display: none;
  margin: 10px 0 10px 20px;
  cursor: pointer;
}

.default-sidebar-icon {
  margin: 10px 0 10px 20px;
  cursor: pointer;

  &--checkout {
    margin-left: 10px;
  }

  &--order-detail {
    margin-left: 15px;
  }
}

// On tablet (<= iPad 800px) the icon rail is gone, so the hamburger must open
// the drawer for every user (it is hidden for non-admin buyers on desktop).
@media only screen and (max-width: 800px) {
  .sidebar-icon {
    display: block;
  }
}
</style>
